import styled from "@emotion/styled";
import checkboxOff from "images/checkbox-off.svg";
import checkboxOn from "images/checkbox-on.svg";
import checkboxDisabled from "images/checkbox-disabled.svg";
import selectArrow from "images/select-arrow.svg";
import person from "images/icon-person.svg";
import close from "images/button-close.svg";
import back from "images/button-back.svg";
import calendarArrow from "images/calendar-arrow.svg";
import imgArrow from "images/more-arrow.svg";

export const MainContents = styled.div`
  min-height: calc(100vh - 44px - 56px);
  min-height: calc((var(--vh, 1vh) * 100) - 100px);
  padding-bottom: 50px;
  padding-left: env(safe-area-inset-left);
  padding-right: env(safe-area-inset-right);
  &.inapp {
    min-height: calc(100vh - 56px);
    min-height: calc((var(--vh, 1vh) * 100) - 56px);
  }
`;

export const HistoryContainer = styled.div`
  min-height: calc(100vh - 197px);
  min-height: calc((var(--vh, 1vh) * 100) - 197px);
  padding-left: env(safe-area-inset-left);
  padding-right: env(safe-area-inset-right);
  &.listPage {
    min-height: calc(100vh - 247px);
    min-height: calc((var(--vh, 1vh) * 100) - 247px);
  }
`;

export const ConfirmContents = styled.div`
  padding-left: env(safe-area-inset-left);
  padding-right: env(safe-area-inset-right);
`;

export const Section = styled.div`
  padding-left: 20px;
  padding-right: 20px;
  .half-width {
    width: 50%;
  }
  &.spaceBottom {
    padding-bottom: 40px;
  }
  &.spaceTop {
    padding-top: 40px;
  }
`;

export const Divider = styled.hr`
  border: 0;
  border-top: 1px solid ${props => props.theme.colors.divider2};

  &.dark {
    border-top-color: ${props => props.theme.colors.divider3};
  }

  &.mt30 {
    margin-top: 30px;
  }
`;

export const TitleWithButton = styled.div`
  display: flex;
  justify-content: space-between;

  h2 {
    margin-top: 0;
  }

  button {
    margin-top: 39px;
  }
`;

export const Title = styled.h2`
  padding-top: 40px;
  font-size: ${props => props.theme.title.sizeFont};
  font-weight: ${props => props.theme.weight.bolder};
  line-height: 1.28;
`;

export const TitleBox = styled.div`
  margin: 0 20px 40px;

  .desc {
    margin-top: 10px;
    color: ${props => props.theme.colors.text2};
    font-size: ${props => props.theme.text.sizeFont};
  }
`;

export const Desc = styled.p`
  margin-top: 10px;
  color: ${props => props.theme.text.colorFont};
  font-size: ${props => props.theme.text.sizeFont};
  line-height: 1.43;
`;

export const Notice = styled.p`
  margin-top: 12px;
  color: ${props => props.theme.text.colorFont};
  font-size: ${props => props.theme.text.sizeFont};

  .emphasis {
    font-weight: ${props => props.theme.weight.bold};
    color: ${props => props.theme.colors.text2};
  }
`;

export const Label = styled.p`
  margin-top: 28px;
  margin-bottom: 8px;
  color: ${props => props.theme.label.colorFont};
  font-size: ${props => props.theme.label.sizeFont};
  font-weight: ${props => props.theme.weight.bolder};
  &.first {
    margin-top: 40px;
  }
`;

export const FooterButtonWrap = styled.div`
  button {
    padding-left: env(safe-area-inset-left);
  }
`;

export const ButtonPrimary = styled.button`
  width: 100%;
  padding: 17px 10px;
  height: 56px;
  background: ${props => props.theme.buttonPrimary.colorBg};
  color: ${props => props.theme.buttonPrimary.colorFont};
  font-size: ${props => props.theme.buttonPrimary.sizeFont};
  font-weight: ${props => props.theme.weight.bolder};
  line-height: 22px;
`;

export const ButtonSmall = styled.button`
  height: 28px;
  padding: 2px 7px 0;
  border: 1px solid ${props => props.theme.buttonSmall.colorBorder};
  border-radius: 3px;
  color: ${props => props.theme.buttonSmall.colorFont};
  font-size: ${props => props.theme.buttonSmall.sizeFont};
`;

export const LookedButtonSmall = styled.span`
  display: inline-block;
  width: 60px;
  height: 28px;
  padding: 6px 7px 0;
  border: 1px solid ${props => props.theme.buttonSmall.colorBorder};
  border-radius: 3px;
  color: ${props => props.theme.buttonSmall.colorFont};
  font-size: ${props => props.theme.buttonSmall.sizeFont};
  text-align: center;
`;

export const ButtonText = styled.button`
  color: ${props => props.theme.buttonText.colorFont};
  font-size: ${props => props.theme.buttonText.sizeFont};
  text-decoration: underline;
  letter-spacing: -0.5px;
`;

export const ButtonArrow = styled.span`
  display: inline-block;
  padding-right: 11px;
  background: url(${imgArrow}) no-repeat 100% 50%;
  color: ${props => props.theme.colors.text2};
  text-decoration: underline;
`;

export const ButtonLink = styled.a`
  color: ${props => props.theme.buttonText.colorFont};
  font-size: ${props => props.theme.buttonText.sizeFont};
  text-decoration: underline;
`;

export const ButtonRound = styled.button`
  width: 100%;
  height: 40px;
  border-radius: ${props => props.theme.radius};
  background-color: ${props => props.theme.colors.primary};
  color: ${props => props.theme.colors.white};
  font-weight: ${props => props.theme.weight.bold};
`;

export const PlaceholderText = styled.span`
  font-size: ${props => props.theme.placeholder.sizeFont};
  font-family: ${props => props.theme.fonts.main};
  font-weight: 400;
  color: ${props => props.theme.placeholder.colorFont};
`;

export const InputText = styled.input`
  padding: 3px 14px 0;
  width: 100%;
  height: 48px;
  border: 1px solid ${props => props.theme.input.colorBorder};
  border-radius: ${props => props.theme.radius};
  font-size: ${props => props.theme.input.sizeFont};
  color: ${props => props.theme.input.colorFont};

  &[data-error="true"] {
    border-color: ${props => props.theme.colors.secondary};
  }

  &[name="identificationBack"] {
    font-family: arial;
  }
`;

export const CheckBox = styled.span`
  display: inline-block;
  width: 22px;
  height: 22px;
  background: url(${checkboxOff}) no-repeat 0 0;
  background-size: 100%;
`;

export const CheckBoxOn = styled.span`
  display: inline-block;
  width: 22px;
  height: 22px;
  background: url(${checkboxOn}) no-repeat 0 0;
  background-size: 100%;
`;

export const CheckBoxDisabled = styled.span`
  display: inline-block;
  width: 22px;
  height: 22px;
  background: url(${checkboxDisabled}) no-repeat 0 0;
  background-size: 100%;
`;

export const CheckBoxWrap = styled.span`
  display: inline-block;

  .input-check {
    display: inline-block;
    width: 22px;
    height: 22px;
    background: url(${checkboxOff}) no-repeat 0 0;
    background-size: 100%;
    vertical-align: top;
  }
  input {
    border: 0;
    clip: rect(0, 0, 0, 0);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    white-space: nowrap;
    width: 1px;
  }
  input:checked + .input-check {
    background-image: url(${checkboxOn});
  }
  input:disabled + .input-check {
    background-image: url(${checkboxDisabled});
  }
`;

export const SelectBox = styled.select`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
  padding: 4px 40px 0 14px;
  height: 48px;
  border: 1px solid ${props => props.theme.selectBox.colorBorder};
  border-radius: ${props => props.theme.radius};
  background: url(${selectArrow}) no-repeat right 8px top 11px;
  background-color: ${props => props.theme.colors.white};
  color: ${props => props.theme.selectBox.colorFont};

  &.nonSelect {
    font-size: ${props => props.theme.placeholder.sizeFont};
    color: ${props => props.theme.placeholder.colorFont};
  }

  &[data-error="true"] {
    position: relative;
    z-index: 1;
    border-color: ${props => props.theme.colors.secondary};
  }
`;

export const DatePickerButton = styled.button`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
  padding: 0px 40px 0 14px;
  height: 48px;
  border: 1px solid ${props => props.theme.selectBox.colorBorder};
  border-radius: ${props => props.theme.radius};
  background: url(${selectArrow}) no-repeat right 8px top 11px;
  background-color: ${props => props.theme.colors.white};
  color: ${props => props.theme.selectBox.colorFont};
  text-align: left;

  &.nonSelect {
    font-size: ${props => props.theme.placeholder.sizeFont};
    color: ${props => props.theme.placeholder.colorFont};
  }

  &[data-error="true"] {
    position: relative;
    z-index: 1;
    border-color: ${props => props.theme.colors.secondary};
  }
`;

export const DatePicker = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
  padding: 14px 40px 0 14px;
  height: 48px;
  border: 1px solid ${props => props.theme.selectBox.colorBorder};
  border-radius: ${props => props.theme.radius};
  background: url(${selectArrow}) no-repeat right 8px top 11px;
  background-color: ${props => props.theme.colors.white};
  color: ${props => props.theme.selectBox.colorFont};
`;

export const SelectGroup = styled.div`
  .first {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }
  .last {
    margin-top: -1px;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }
  .react-datepicker-wrapper,
  .react-datepicker__input-container {
    width: 100%;
  }

  &.row {
    display: flex;
    justify-content: space-between;

    .first,
    .last {
      border-radius: 5px;
    }

    .last {
      margin-top: 0;
    }
  }

  .selectDay {
    width: 60%;
  }
  .selectTime {
    width: 36.7%;
  }
`;

export const RadioGroup = styled.div`
  display: flex;

  label {
    &:first-of-type {
      .radioButton {
        border-right: 1px solid transparent;
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;
      }
      input: checked + .radioButton {
        border-right-width: 1px;
      }
    }
    &:last-of-type {
      .radioButton {
        border-left: 1px solid transparent;
        border-top-right-radius: 5px;
        border-bottom-right-radius: 5px;
      }
      input: checked + .radioButton {
        border-left-width: 1px;
      }
    }
  }
`;

export const Radio = styled.label`
  flex: 1;

  input {
    display: none;
  }

  .radioButton {
    display: block;
    width: 100%;
    padding: 14px 12px 0;
    height: 48px;
    border: 1px solid ${props => props.theme.input.colorBorder};
    color: ${props => props.theme.input.colorFont};
    font-size: ${props => props.theme.input.sizeFont};
    text-align: center;
  }

  input:checked + .radioButton {
    border-color: ${props => props.theme.colors.primary};
    color: ${props => props.theme.colors.primary};
    font-weight: ${props => props.theme.weight.bolder};
  }
`;

export const IconPerson = styled.span`
  display: inline-block;
  width: 16px;
  height: 20px;
  background: url(${person}) no-repeat;
`;

export const ButtonClose = styled.button`
  width: 40px;
  height: 40px;
  background: url(${close}) no-repeat 50% 50%;
`;

export const ButtonBack = styled.button`
  width: 40px;
  height: 40px;
  background: url(${back}) no-repeat 50% 50%;
`;

export const Table = styled.table`
  border-top: 1px solid ${props => props.theme.colors.divider};
  border-bottom: 1px solid ${props => props.theme.colors.divider2};
  word-break: break-all;
  line-height: 1.45;

  thead th {
    padding: 18px 5px;
    border-left: 1px solid ${props => props.theme.colors.divider2};
    font-weight: 600;
  }
  thead tr th:first-of-type {
    width: 36%;
    border-left: 0;
  }
  tbody th,
  tbody td {
    border-top: 1px solid ${props => props.theme.colors.divider2};
  }
  tbody th {
    padding: 10px 12px;
    font-size: ${props => props.theme.text.sizeFontXS};
    font-weight: 600;
    text-align: left;
  }
  tbody td {
    border-left: 1px solid ${props => props.theme.colors.divider2};
    font-size: ${props => props.theme.text.sizeFont};
    text-align: center;
  }
`;

export const DatePickerWrap = styled.div`
  .b-calendar {
    &.react-datepicker {
      border: 0;
      border-radius: 10px;
      font-family: ${props => props.theme.fonts.main};
      font-size: ${props => props.theme.calendar.font};
      color: ${props => props.theme.colors.text};
    }
  }

  .react-datepicker__day-name {
    color: ${props => props.theme.calendar.disabledColor};
  }
  .react-datepicker__day,
  .react-datepicker__time-name {
    color: inherit;
  }

  .react-datepicker__day--disabled,
  .react-datepicker__month-text--disabled {
    color: ${props => props.theme.calendar.disabledColor};
  }

  .react-datepicker__day--selected,
  .react-datepicker__day--in-selecting-range,
  .react-datepicker__day--in-range,
  .react-datepicker__month-text--selected,
  .react-datepicker__month-text--in-selecting-range,
  .react-datepicker__month-text--in-range,
  .react-datepicker__day--keyboard-selected,
  .react-datepicker__month-text--keyboard-selected {
    color: ${props => props.theme.colors.white};
  }

  .react-datepicker__header {
    padding-top: 20px;
    border-bottom: 0;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    background-color: ${props => props.theme.colors.white};
  }
  .react-datepicker__portal .react-datepicker__current-month,
  .react-datepicker__portal .react-datepicker-time__header {
    font-size: ${props => props.theme.calendar.headerFont};
  }

  .react-datepicker__current-month,
  .react-datepicker-time__header,
  .react-datepicker-year-header {
    color: ${props => props.theme.calendar.headerColor};
    font-weight: 800;
  }

  .react-datepicker__current-month {
    padding-top: 6px;
    padding-bottom: 6px;
  }

  @media (max-width: 400px), (max-height: 550px) {
    .react-datepicker__portal .react-datepicker__day-name,
    .react-datepicker__portal .react-datepicker__day,
    .react-datepicker__portal .react-datepicker__time-name {
      width: 2.6rem;
      line-height: 2.6rem;
    }
  }

  .react-datepicker__day--keyboard-selected,
  .react-datepicker__month-text--keyboard-selected,
  .react-datepicker__day--selected {
    background-color: ${props => props.theme.colors.primary};
    border-radius: 50%;
  }

  .react-datepicker__day--in-selecting-range,
  .react-datepicker__day--in-range,
  .react-datepicker__month-text--selected,
  .react-datepicker__month-text--in-selecting-range,
  .react-datepicker__month-text--in-range {
    background-color: ${props => props.theme.colors.primary};
    border-radius: 0;
  }
  .react-datepicker__day--range-start {
    border-top-left-radius: 50%;
    border-bottom-left-radius: 50%;
  }
  .react-datepicker__day--range-end {
    border-top-right-radius: 50%;
    border-bottom-right-radius: 50%;
  }
  .react-datepicker__portal .react-datepicker__navigation--previous {
    transform: rotate(180deg);
  }
  .react-datepicker__portal .react-datepicker__navigation {
    width: 40px;
    height: 40px;
    border: 0;
    background: url(${calendarArrow}) no-repeat 50% 50%;
  }
  .react-datepicker__navigation {
    top: 18px;
  }
  react-datepicker__day-names {
    margin-top: 5px;
  }
  .react-datepicker__today-button {
    padding-top: 8px;
    padding-bottom: 8px;
    border-top-color: ${props => props.theme.colors.divider2};
    background-color: ${props => props.theme.colors.white};
    color: ${props => props.theme.colors.primary};
  }
  .react-datepicker__day-name,
  .react-datepicker__day,
  .react-datepicker__time-name {
    margin-left: 0;
    margin-right: 0;
  }
`;

export const TermsPopupContents = styled.div`
  color: ${props => props.theme.text.colorFont};
  font-size: ${props => props.theme.text.sizeFontM};
  line-height: 1.43;
`;

export const RowGroup = styled.div`
  display: flex;
  justify-content: space-between;

  .left {
    width: 60%;
  }
  .right {
    width: 36.7%;
  }
`;
